import { Modal } from "react-bootstrap"
import { useActions } from "@/hooks/useActions"
import { useAppDispatch } from "@/redux/store"
import { clearQrId } from "@/redux/slices/events/eventsSlice"
import styles from "./DeleteImageModal.module.scss"

const DeleteImageModal = ({ show, setShow }: any) => {
  const { deleteImage, setImage, setCroppedImagePath } = useActions()
  const dispatch = useAppDispatch()

  const onDelete = () => {
    deleteImage()
    setImage(null)
    setCroppedImagePath(null)
    dispatch(clearQrId())
    setShow(false)
  }

  return (
    <Modal
      className={`${styles.addPopup} delete-image-modal`}
      show={show}
      onHide={() => setShow(!show)}
    >
      <Modal.Header className={styles.close} closeButton></Modal.Header>
      <Modal.Body>
        <div className={styles.body}>
          <h2 className={`caption ${styles.caption}`}>
            Do you really want to remove the image?
          </h2>

          <div className={styles.controls}>
            <span className="btn btn-dark" onClick={onDelete}>
              {"Yes"}
            </span>
            <button onClick={() => setShow(!show)} className="btn btn-simple">
              {"No"}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DeleteImageModal
